import { ComponentProps } from 'react';

import { Body } from '@growtherapy/sprout-ui';

import { Appointment } from '../types';
import { asTimeWithTimeZone } from '../utils';

export interface AppointmentTimeProps extends ComponentProps<typeof Body.Xsmall> {
  appointment?: Pick<Appointment, 'timeStart'> | null;
  isLoading?: boolean;
  variant?: 'xs' | 'sm';
}
export function AppointmentTime({ appointment, isLoading, variant = 'sm', ...textProps }: AppointmentTimeProps) {
  const appointmentText = isLoading ? (
    '...'
  ) : appointment?.timeStart ? (
    `Appointment at ${asTimeWithTimeZone(appointment.timeStart)}`
  ) : (
    <i>Appointment details not found</i>
  );

  const TextComponent = variant === 'xs' ? Body.Xsmall : Body.Small;

  return (
    <TextComponent
      className='text-left fs-exclude arc:text-text-default'
      data-dd-privacy='mask'
      data-dd-action-name='appointment time'
      data-testid='appointment-time'
      {...textProps}
    >
      {appointmentText}
    </TextComponent>
  );
}
